export const ENDPOINT = {
  // mileage
  MILEAGE: `/api/mileage`,
  ETC_MILEAGE: `/api/mileage/etc`,
  // scholarship
  SCHOLARSHIP_APPLY: `/api/mileage/apply`,
  // auth
  AUTH: `/api/mileage/auth`,
  // user
  USER: `/api/mileage/users`,
  // capability
  CAPABILITY: `/api/mileage/capability`,
};
